<script setup lang="ts">
import { computed } from 'vue'

import AppButton from 'primevue/button'
import { useThemeStore } from '@/stores/useThemeStore'

const themeStore = useThemeStore()

const buttonIcon = computed(() => (themeStore.isDark ? 'pi pi-sun' : 'pi pi-moon'))
const buttonSeverity = computed(() => (themeStore.isDark ? 'primary' : 'secondary'))
const tooltipText = computed(() => (themeStore.isDark ? 'Modo Claro' : 'Modo Oscuro'))

function toggleTheme() {
  themeStore.toggleDark()
}
</script>

<template>
  <div class="flex items-center">
    <AppButton
      rounded
      :severity="buttonSeverity"
      variant="outlined"
      :icon="buttonIcon"
      v-tooltip.bottom="tooltipText"
      @click="toggleTheme"
    />
  </div>
</template>
